import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Fab } from "@mui/material";
import AddLinkRounded from "@mui/icons-material/AddLinkRounded";
import { withPather } from "react-pather";

const SCROLL_Y_THRESHOLD = 300; // TODO: try to use dynamic value calculated based on vh (VieportHight) for different screens

const ShortenFAB = ({ pather }) => {
  const location = useLocation();

  const [showFab, setShowFab] = useState(false);

  useEffect(() => {
    if (
      location.pathname !== pather.front.dashboard &&
      location.pathname !== "/settings/forgotten"
    ) {
      setShowFab(true);
      return;
    }

    const handleScroll = () => {
      setShowFab(window.scrollY > SCROLL_Y_THRESHOLD);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll(); // Check scroll position on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return showFab && location.pathname !== pather.front.shorten ? (
    <Fab
      color="primary"
      component={Link}
      to={pather.front.shorten}
      sx={{
        position: "fixed",
        bottom: 30,
        left: 30,
      }}
    >
      <AddLinkRounded />
    </Fab>
  ) : null;
};

export default withPather()(ShortenFAB);